<div class="loader-container" *ngIf="showLoader">
  <div class="loader">
    <mat-spinner [diameter]="40"></mat-spinner>
    <span class="loader-msg">{{loadingMessage}}</span>

  </div>
</div>
